/**
 * TanStack Query hooks for `fully-customizable-dashboard-widgets`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fullyCustomizableDashboardWidgetsQueryKeys,
	type CreateFullyCustomizableDashboardWidgetsBody,
	type ListFullyCustomizableDashboardWidgetsResponse,
	type FullyCustomizableDashboardWidgetsRow,
} from "./api";

export function useFullyCustomizableDashboardWidgetsList(): UseQueryResult<ListFullyCustomizableDashboardWidgetsResponse, Error> {
	return useQuery({
		queryKey: fullyCustomizableDashboardWidgetsQueryKeys.list(),
		queryFn: list,
	});
}

export function useFullyCustomizableDashboardWidgetsCreate(): UseMutationResult<FullyCustomizableDashboardWidgetsRow, Error, CreateFullyCustomizableDashboardWidgetsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fullyCustomizableDashboardWidgetsQueryKeys.all });
		},
	});
}

export function useFullyCustomizableDashboardWidgetsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fullyCustomizableDashboardWidgetsQueryKeys.all });
		},
	});
}
